import { FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material'
import React, { Dispatch, SetStateAction } from 'react'

import SortMenu from 'components/common/SortMenu'
import {
  DEFAULT_DASHBOARD_LIST_SORTS,
  DASHBOARD_LIST_GROUP_BY_OPTIONS,
  SortParam,
  DASHBOARD_LIST_SORT_MENU_ITEMS,
  DEFAULT_DASHBOARD_LIST_SORT_ORDERS
} from 'components/reliability-management/company-dashboard/rm-company-dashboard-utils'
import { Pagination } from 'hooks/use-pagination'
import { DEFAULT_SORT_CATEGORY, StoredSorts } from 'hooks/use-stored-sorts'
import { ServicesGroup } from 'types/api/policies/reliability-report'

export const DashboardListControls: React.FC<{
  groupBy: ServicesGroup
  pagination: Pagination
  setGroupBy: Dispatch<SetStateAction<ServicesGroup>>
  sorts: SortParam
  setSorts: Dispatch<SetStateAction<StoredSorts>>
}> = ({ groupBy, pagination, setGroupBy, sorts, setSorts }) => {
  return (
    <Stack
      alignItems="center"
      direction="row"
      id="CompanyDashboardListControls"
      justifyContent="space-between"
    >
      <FormControl css={{ minWidth: 200 }}>
        <InputLabel id="group-by-select">Group by</InputLabel>
        <Select
          data-test-select-group-by
          label="Group by"
          labelId="group-by-select"
          value={groupBy}
          onChange={(event) => {
            setGroupBy(event.target.value as ServicesGroup)
            setSorts(DEFAULT_DASHBOARD_LIST_SORTS[event.target.value])
          }}
        >
          {Object.values(DASHBOARD_LIST_GROUP_BY_OPTIONS).map(
            ({ value, label }) => {
              return (
                <MenuItem
                  key={value}
                  data-test-group-by-menu-item={value}
                  value={value}
                >
                  {label}
                </MenuItem>
              )
            }
          )}
        </Select>
      </FormControl>
      <SortMenu
        menuItems={DASHBOARD_LIST_SORT_MENU_ITEMS[groupBy]}
        sortField={sorts[DEFAULT_SORT_CATEGORY].field}
        sortOrder={sorts[DEFAULT_SORT_CATEGORY].order}
        onSortMenuChange={(value) => {
          setSorts({
            ...sorts,
            [DEFAULT_SORT_CATEGORY]: {
              field: value,
              order: DEFAULT_DASHBOARD_LIST_SORT_ORDERS[groupBy][value]
            }
          })

          // Reset pagination to page 0
          pagination.changePage(0)
        }}
        onSortOrderClick={() => {
          setSorts({
            ...sorts,
            [DEFAULT_SORT_CATEGORY]: {
              field: sorts[DEFAULT_SORT_CATEGORY].field,
              order:
                sorts[DEFAULT_SORT_CATEGORY].order === 'desc' ? 'asc' : 'desc'
            }
          })

          // Reset pagination to page 0
          pagination.changePage(0)
        }}
      />
    </Stack>
  )
}
